(function () {
  'use strict';

  function initProductGallery() {
    var track = document.querySelector('.vg-track');
    var slides = document.querySelectorAll('.vg-slide');
    var thumbs = document.querySelectorAll('.vg-thumb');
    var prevBtn = document.querySelector('.vg-arrow--prev');
    var nextBtn = document.querySelector('.vg-arrow--next');

    if (!track || slides.length === 0) return;

    var current = 0;
    var total = slides.length;
    var navigating = false; // suppresses IntersectionObserver during programmatic scrolls
    var navTimer = null;

    // ── Activate slide & matching thumb ──────────────────────────────────────
    function activate(index, behavior) {
      behavior = behavior || 'instant';
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      current = index;

      // Suppress the IntersectionObserver for the duration of the scroll animation
      navigating = true;
      clearTimeout(navTimer);
      navTimer = setTimeout(function () { navigating = false; }, behavior === 'smooth' ? 600 : 50);

      slides.forEach(function (s, i) {
        s.classList.toggle('vg-slide--active', i === current);
        s.setAttribute('aria-hidden', i === current ? 'false' : 'true');
      });

      thumbs.forEach(function (t, i) {
        var isActive = i === current;
        t.classList.toggle('vg-thumb--active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        t.setAttribute('tabindex', isActive ? '0' : '-1');
        var dot = t.querySelector('.vg-dot');
        if (dot) dot.style.display = isActive ? 'block' : 'none';
      });

      // Scroll main slide into view
      slides[current].scrollIntoView({ behavior: behavior, inline: 'start', block: 'nearest' });

      // Scroll active thumb into view in the strip
      if (thumbs[current]) {
        thumbs[current].scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      }
    }

    // ── Arrow buttons — smooth scroll on click ────────────────────────────────
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        activate(current - 1, 'smooth');
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        activate(current + 1, 'smooth');
      });
    }

    // ── Thumbnail clicks ──────────────────────────────────────────────────────
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        activate(i);
      });
      // Also support keyboard activation via Enter/Space
      thumb.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activate(i);
        }
      });
    });

    // ── IntersectionObserver: sync state when user swipes natively ────────────
    // Uses 'instant' so we don't double-scroll (CSS scroll-snap already handled the swipe)
    // Skips during programmatic navigation to prevent wrap-around race condition
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var topEntry = null;
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !navigating) {
            if (!topEntry || entry.intersectionRatio > topEntry.intersectionRatio) {
              topEntry = entry;
            }
          }
        });

        if (topEntry) {
          var idx = Array.prototype.indexOf.call(slides, topEntry.target);
          if (idx !== -1 && idx !== current) {
            activate(idx, 'instant');
          }
        }
      }, { root: track, threshold: 0.5 });

      slides.forEach(function (s) { io.observe(s); });
    }

    // ── Keyboard navigation — smooth scroll ───────────────────────────────────
    document.addEventListener('keydown', function (e) {
      var gallery = e.target.closest('.product-images-hlf-container');
      if (!gallery) return;

      var el = document.activeElement;
      if (el && (
        el.tagName === 'INPUT' ||
        el.tagName === 'TEXTAREA' ||
        el.tagName === 'SELECT' ||
        el.isContentEditable ||
        el.getAttribute('role') === 'textbox'
      )) return;
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        activate(current - 1, 'smooth');
      }
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        activate(current + 1, 'smooth');
      }
    });

    // Init first slide
    activate(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductGallery);
  } else {
    initProductGallery();
  }
})();
